import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

export const useDefaultValueForField = (
  fieldPath: string,
  defaultValue: unknown,
) => {
  const { getValues, setValue } = useFormContext();

  useEffect(() => {
    const currentValue = getValues(fieldPath) as unknown;

    if (currentValue === undefined || currentValue === null) {
      setValue(fieldPath, defaultValue);
    }
  }, [fieldPath, setValue, getValues, defaultValue]);
};
